jQuery(document).ready(function($) {

    $( ".bloc_liens" ).each(function( index ) {

        var parent = $(this).find(".acces")
        var cibleAcces = parent.find(".anim")

        gsap.from( cibleAcces, {
            y : +200,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 100%",
                end: "top 50%",
                scrub: 1,
            }

        })

    })

});